'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Prismic;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _context = require('./context');

var _context2 = _interopRequireDefault(_context);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Prismic(props) {
  var repo = props.repo,
      ref = props.ref,
      lang = props.lang,
      children = props.children;
  return _react2.default.createElement(_context2.default.Provider, {
    value: {
      repo: repo,
      ref: ref,
      lang: lang
    }
  }, children);
}

Prismic.propTypes = {
  /** The prismic repository name. */
  repo: _propTypes2.default.string,

  /** The ref option defines which version of your content to query.
   * By default prismic will use the master ref
   * to retrieve the currently published documents. */
  ref: _propTypes2.default.string,

  /** Defines the language code for the results of your query.
   * For example "en-us" for American English.
   * If no lang is provided, then the query will default to
   * the master language of the repository.
   * You can also pass the wilcard value * to specify that you want to query
   * documents in all available languages. * */
  lang: _propTypes2.default.string,

  /**
   * This prop should not be visible in the documentation.
   * @ignore
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.object])
};
Prismic.defaultProps = {
  repo: undefined,
  ref: undefined,
  lang: undefined,
  children: null
};